// Referral tier configuration
export const TIERS = [
  {
    key: "bronzo",
    name: "Bronzo",
    min: 0,
    max: 4,
    perks: ["Accesso alla waitlist", "Newsletter privata"],
  },
  {
    key: "argento",
    name: "Argento",
    min: 5,
    max: 14,
    perks: [
      "Priorità ingresso alle nuove aperture",
      "Anteprima dei progetti 24h prima",
    ],
  },
  {
    key: "oro",
    name: "Oro",
    min: 15,
    max: 49,
    perks: [
      "Late check-out gratuito (fino alle 18:00)",
      "Bottiglia di benvenuto in camera",
      "Priorità upgrade suite in bassa stagione",
    ],
  },
  {
    key: "platino",
    name: "Platino",
    min: 50,
    max: Infinity,
    perks: [
      "Invito alle serate private di inaugurazione",
      "Upgrade suite garantito ove disponibile",
      "Concierge dedicato via WhatsApp",
      "Voucher trasferibile una volta l'anno",
    ],
  },
];

export function tierForCount(count) {
  return TIERS.find((t) => count >= t.min && count <= t.max) || TIERS[0];
}

export function nextTier(count) {
  const idx = TIERS.findIndex((t) => count >= t.min && count <= t.max);
  if (idx < 0 || idx === TIERS.length - 1) return null;
  return TIERS[idx + 1];
}

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const s = Math.max(1, Math.floor((Date.now() - d.getTime()) / 1000));
  if (s < 60) return `${s}s fa`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m fa`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h fa`;
  const days = Math.floor(h / 24);
  return `${days}g fa`;
}
